import { useMutation, useQueryClient } from "@tanstack/react-query";

import { submitCarbonProgramDraft } from "services";

import { GET_CARBON_PROGRAM_DRAFT, GET_CARBON_PROGRAM_DRAFTS, SUBMIT_CARBON_PROGRAM_DRAFT } from "consts";

export const useSubmitCarbonProgramDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [SUBMIT_CARBON_PROGRAM_DRAFT],
    mutationFn: submitCarbonProgramDraft,
    onSuccess: (draft) => {
      queryClient.invalidateQueries({ queryKey: [GET_CARBON_PROGRAM_DRAFTS] });
      queryClient.setQueryData([GET_CARBON_PROGRAM_DRAFT, draft.id], draft);
    },
  });
};
